import { useNavigate } from 'react-router-dom';
import type { ArticlePost } from '@/lib/articles';

interface Props {
  post: ArticlePost;
}

const BlogDetailHero = ({ post }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="relative">
      {/* Cover */}
      <div className="h-80 relative overflow-hidden">
        <img
          src={post.coverImage}
          alt={post.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-[#0A1628]/50 to-transparent" />
      </div>

      {/* Breadcrumb & Meta */}
      <div className="absolute bottom-0 left-0 right-0 px-6 pb-8">
        <div className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-white/60 mb-4">
            <button
              onClick={() => navigate('/')}
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              首頁
            </button>
            <i className="ri-arrow-right-s-line" />
            <button
              onClick={() => navigate('/blog')}
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              資源中心
            </button>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/80 truncate">{post.category}</span>
          </nav>

          <div className="flex items-center gap-2 mb-3">
            <span className={`bg-gradient-to-r ${post.gradient} text-white text-xs font-bold px-3 py-1.5 rounded-full`}>
              {post.category}
            </span>
            {post.featured && (
              <span className="bg-amber-500/20 text-amber-300 text-xs font-semibold px-3 py-1.5 rounded-full border border-amber-400/30">
                精選文章
              </span>
            )}
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-white leading-tight mb-4 max-w-3xl">
            {post.title}
          </h1>

          <div className="flex items-center gap-5 flex-wrap">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full overflow-hidden border-2 border-white/20">
                <img src={post.authorAvatar} alt={post.author} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">{post.author}</p>
                <p className="text-xs text-white/60">{post.authorRole} · {post.authorCompany}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 text-xs text-white/50">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line" />
                {new Date(post.publishedAt).toLocaleDateString('zh-TW', { year: 'numeric', month: 'long', day: 'numeric' })}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line" />
                {post.readTime} 分鐘閱讀
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line" />
                {post.views.toLocaleString()} 次閱讀
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-heart-line" />
                {post.likes} 按讚
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailHero;
